module.exports = __webpack_public_path__ + "static/media/terminalillness.988ca6dc.svg";